import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";

export const container: CSSProperties = {
  width: "100%",
};

export const onboardingContainer: CSSProperties = {
  ...container,
  border: `1px solid ${greys.borderGrey}`,
  borderRadius: 5,
  padding: "0 12px",
  "&.active": {
    border: `1px solid ${colors.green.lighter}`,
  },
};

const searchRow: CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
};

const cancel: CSSProperties = {};

const searchField: CSSProperties = {
  width: 20,
  height: 20,
};

const textWrapper: CSSProperties = {
  width: "100%",
  paddingRight: 12,
};

const textWrapperOnboarding: CSSProperties = {
  width: "100%",
};

const textField: CSSProperties = {
  width: "100%",
  margin: "10px 0",
};

// ~-~-~-~-~-~-~-
// Autosuggest Styles
// ~-~-~-~-~-~-~-
const suggestionContainer: CSSProperties = {
  position: "relative",
};

const suggestion: CSSProperties = {
  display: "block",
};

const suggestionHighlighted: CSSProperties = {
  backgroundColor: greys.paleGrey,
};

const suggestionsList: CSSProperties = {
  margin: 0,
  padding: 0,
  listStyleType: "none",
};

export const styles = {
  container,
  onboardingContainer,
  searchRow,
  cancel,
  searchField,
  textWrapper,
  textWrapperOnboarding,
  textField,
  suggestionContainer,
  suggestion,
  suggestionHighlighted,
  suggestionsList,
};
